import React from "react";
import AvailabilityCard from "@/components/nds/windows/sch/avail/AvailabilityCard";

export default function SchAvailabilityContent() {
  return <div data-testid="sch-availability-window" className="p-4 h-full overflow-auto"><AvailabilityCard /></div>;
}
